<template>
  <div class="card">
    <div class="stripe-account-error card-body">
      <i class="far fa-exclamation-triangle" />
      <h1>Stripe Account Error</h1>
      <p>
        We've had trouble accessing the Stripe account you previously connected.
      </p>
      <div
        v-if="!hasCustomers"
        class="can-reset"
      >
        <p>
          This can occur if you have deleted the connected account on Stripe.
        </p>
        <p v-if="!hasProducts">
          We have found that you currently haven't saved any products.
        </p>
        <p v-else>
          We've found that you have previously created products within our platform.
        </p>
        <p>
          If you are happy to, we can reset your merchant account and allow you to reconnect it to Stripe.
        </p>
        <p v-if="hasProducts">
          This will remove any products and prices you have already configured.
        </p>

        <p>
          If you are unsure, please contact us at support@hikeseo.co
        </p>

        <button
          class="btn btn-md btn-danger"
          @click="resetStripeMerchantAccount"
        >
          Reset Connected Stripe Account
        </button>
      </div>

      <div v-else>
        <p>
          We have already notified our support team who will be in contact soon.
        </p>
        <p>
          You can contact us directly at support@hikeseo.co for assistance
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import axios from 'axios';
import {mapActions, mapGetters} from "vuex";

// As part of error response, consider including a bool for safe to reset, based on stored products and customers
export default {
  computed: {
    ...mapGetters('merchantCentreSetupWizard', [
      'stripeAccountError',
    ]),
    hasCustomers() {
      return this.stripeAccountError.merchantHasCustomers
    },
    hasProducts() {
      return this.stripeAccountError.merchantHasProudcts
    },
  },
  mounted() {
    this.fetchCompanyInfo();
  },
  methods: {
    ...mapActions('stripeConnectDashboard', [
      'fetchCompanyInfo',
    ]),
    resetStripeMerchantAccount() {
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure?',
        html: `
          This action will reset your merchant account and remove any configured products and prices.
          <br>
          If you are unsure, please reach out to support@hikeseo.co
        `,
        showCancelButton: true,
        confirmButtonText: 'Reset Account',
        confirmButtonColor: '#F34F4F',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          return axios.post('/merchant/reset-merchant-account')
            .then(() => {
              Swal.fire({
                icon: 'success',
                title: 'Account reset successfully',
                didClose: () => {
                  location.reload();
                }
              });
            }).catch(() => {
              Swal.fire({
                  icon: 'error',
                  title: 'Whoops',
                  html: 'Something went wrong, please contact support@hikeseo.co'
              });
            })
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.stripe-account-error, .can-reset {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stripe-account-error i {
  font-size: 4rem;
  color: var(--negative-color);
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;
}

p {
  font-size: 1rem;
  text-align: center;
}
</style>
